export const safariScrollFix = (iframe: HTMLIFrameElement): void => {
  iframe.contentDocument!.body.style.display = 'none';
  // tslint:disable-next-line
  iframe.contentDocument!.body.offsetHeight;
  iframe.contentDocument!.body.style.display = 'block';
};
